import { Card, Statistic } from "antd";
import { METRO_COLORS } from "../../constants/colors";

export const EventCounter = ({ title, count, status }) => {
  const statusColors = {
    abierto: METRO_COLORS.status.abierto,
    ejecutando: METRO_COLORS.status.ejecutando,
    falsa_alarma: METRO_COLORS.status.falsa_alarma,
    validado: METRO_COLORS.status.validado,
    default: METRO_COLORS.status.default,
  };

  return (
    <Card
      className="text-center shadow-md hover:shadow-lg transition-shadow duration-300 border-0"
      bodyStyle={{
        padding: "15px",
        borderTop: `4px solid ${statusColors[status]}`,
      }}
    >
      <Statistic
        title={title}
        value={count}
        valueStyle={{
          color: statusColors[status],
          fontSize: "2.5rem",
          fontWeight: "bold",
        }}
      />
    </Card>
  );
};
